import React, { useEffect, useState, useRef, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../../components/common/Loader";
import SnackbarToast from "../../../../components/common/SnackBar";
import activeIcon from "../../../../assets/images/register-step-right.svg";
import InspectionArrow from "../../../../assets/images/inspection-arrow.svg";
import infoIcon from "../../../../assets/images/info_icon.svg";
import { toast } from "react-toastify";
import { createSlug } from "../../../../helpers/common";
import { FieldArray, Formik } from "formik";
import * as Yup from "yup";
import {
  getFieldSheetDataAPI,
  updateFieldSheetDataAPI,
} from "../../../../services/inspectionRequest";
import {
  Button,
  Col,
  Form,
  Row,
  Stack,
  Container,
  Card,
  Spinner,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import InputText from "../../../../components/common/InputText";
import InputSelect from "../../../../components/common/InputSelect";
import InputTextArea from "../../../../components/common/TextArea";
import { nameBasedProtectedRoutes } from "../../../../router/protected";
import GroupDataset from "./GroupDataset";
import { inspectionTyppeWithoutKey } from "../../../../constants/constants";
import { deficiencyCompleteAPI } from "services/deficiency";
import { MESSAGES } from "constants/messages";
import { MyContext } from "MyProvider";

import { useFormikContext } from "formik";
export const AutoSave = ({ onSave }) => {
  const { values } = useFormikContext();
  const prevValues = useRef(values);

  useEffect(() => {
    if (JSON.stringify(prevValues.current) !== JSON.stringify(values)) {
      onSave(values);
      prevValues.current = values;
    }
  }, [values, onSave]);

  return null;
};


export const InspectionForm = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const state = location.state;
  const [fieldSheetData, setFieldSheetData] = useState([]);
  const [activeStep, setActiveStep] = useState(1);
  const [completedStep, setCompletedStep] = useState(1);
  const [tempSteps, setTempSteps] = useState();
  const [btnLoading, setBtnLoading] = useState(false);
  const [height, setHeight] = useState(0);

  const { model_number, serial_number } = state;
  const [showSnackBar, setshowSnackBar] = useState({
    show: false,
    message: "",
    severity: "",
  });
  const { myState } = useContext(MyContext);
  const divRef = useRef(null);

  const deficiencyType = [
    inspectionTyppeWithoutKey.Annual,
    inspectionTyppeWithoutKey.Maritime,
    inspectionTyppeWithoutKey.Prepurchase,
  ];
  const inspectionDoneType = [
    inspectionTyppeWithoutKey.Training,
    inspectionTyppeWithoutKey.Incident,
    inspectionTyppeWithoutKey.LoadTest,
    inspectionTyppeWithoutKey.MachineEvaluation,
  ];

  const getSheetData = () => {
    const fieldSheet_id = state.inspection_data_sheet_id;
    getFieldSheetDataAPI(fieldSheet_id)
      .then((response) => {
        setFieldSheetData(response.form_data);
        setActiveStep(response.active_step);
        setCompletedStep(response.active_step);
        if (divRef.current) {
          const divHeight = divRef.current.offsetHeight;

          setHeight(divHeight + 15);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getSheetData();
  }, []);

  const handleClose = () => {
    setshowSnackBar({
      show: false,
      message: "",
      severity: "",
    });
  };

  const transformedArray = (originalArray) => {
    const newOptions = originalArray.map((item) => {
      return {
        key: item.label,
        value: item.label,
      };
    });
    return newOptions;
  };

  const getInitialValues = (fieldValues) => {
    const myObject = {};
    fieldValues.map((valid) => {
      if (valid.type == "text" || valid.type == "textarea") {
        myObject[valid.name] = valid.value ? valid.value : valid?.default_value;
      }
      if (valid.type == "dropdown") {
        myObject[valid.name] = valid.value ? valid.value : "";
      }
      if (valid.type == "checkbox") {
        valid.data_set.forEach((element, key) => {
          myObject[valid.name + `${element.label}`] = element.checked
            ? element.checked
            : false;
        });
      }
      if (valid.type == "dataset") {
        valid.data_set &&
          valid.data_set.map((dset, parent_index) => {
            Array.from({
              length: valid.data_set_row,
            }).map((dsubset, setIndex) => {
              if (valid.data_set[parent_index]?.content_type?.value == "text") {
                const propName = `${valid.name}text${parent_index}content${setIndex}`;
                myObject[`${valid.name}text${parent_index}content${setIndex}`] =
                  valid.data_set[parent_index][propName]
                    ? valid.data_set[parent_index][propName]
                    : valid.data_set[parent_index]?.content;
              }
              if (
                valid.data_set[parent_index]?.content_type?.value == "dropdown"
              ) {
                const propName = `${valid.name}select${parent_index}content${setIndex}`;
                myObject[
                  `${valid.name}select${parent_index}content${setIndex}`
                ] = valid.data_set[parent_index][propName]
                  ? valid.data_set[parent_index][propName]
                  : "";
                // valid.data_set[parent_index]?.content_array[setIndex]?.label
              }
            });
          });
      }
      if (valid.type == "group-dataset") {
        valid.data_set.forEach((element, gKey) => {
          if (element.content_type.value == "checkbox") {
            element.content_array.forEach((check, key) => {
              myObject[valid.name + `${check.label}${gKey}${key}`] =
                check.checked ? check.checked : false;
            });
          }
          if (element.content_type.value == "text") {
            myObject[valid.name + gKey] = element.value
              ? element.value
              : element?.content;
          }
          if (element.content_type.value == "dropdown") {
            myObject[valid.name + gKey] = element.value ? element.value : "";
          }
        });
      }
    });
    return myObject;
  };

  const openDeficiencyReport = () => {
    if (deficiencyType.some((item) => item === state.inspectionType)) {
      navigate(nameBasedProtectedRoutes.deficiencyReport.path, {
        state: {
          inspection_id: state?.inspection_id,
          machine_id: state?.machine_id,
        },
      });
    } else if (
      inspectionDoneType.some((item) => item === state.inspectionType)
    ) {
      inspectionDone(state?.machine_id);
    } else {
      navigate(nameBasedProtectedRoutes.UnsatisfactoryReport.path, {
        state: {
          inspection_id: state?.inspection_id,
          machine_id: state?.machine_id,
        },
      });
    }
  };

  const inspectionDone = (machine_id) => {
    const formData = {
      acknowledgement: "inspection done",
      machine_id: machine_id,
    };
    deficiencyCompleteAPI(formData)
      .then((response) => {
        setBtnLoading(false);
        toast.success(MESSAGES.machineInspecctionDone);
        navigate(myState, { state: { travelPopup: true } });
      })
      .catch((error) => {
        setBtnLoading(false);
      });
  };

  const updateSheetData = (values,autoSaving = false) => {
    const fieldSheet_id = state.inspection_data_sheet_id;
    const formActiveStep = autoSaving ? -1 : (fieldSheetData.length == tempSteps ? tempSteps - 1 : tempSteps)

    if(!autoSaving)
      setBtnLoading(true);

    const formData = {
      form_data: fieldSheetData,
      active_step: formActiveStep,
    };
    updateFieldSheetDataAPI(fieldSheet_id, formData)
      .then((response) => {
        // setFieldSheetData(response.form_data);
        setBtnLoading(false);
        if(!autoSaving){
          if (fieldSheetData.length == tempSteps) {
            openDeficiencyReport();
          } else {
            setActiveStep(tempSteps);
          }
          setCompletedStep(tempSteps);
        }
      })
      .catch((error) => {
        setBtnLoading(false);
      });
  };
  const handleSubmit = async (values) => {
    setBtnLoading(true);
    await updateSheetData(values);
  };

  const getValidationSchema = (fieldValues) => {
    let schemaObject = {};

    for (const element of fieldValues) {
      if (element.require) {
        const propertyName = element.name;
        if (element.type == "checkbox") {
          if (element.data_set.every((obj) => !obj.checked)) {
            schemaObject[propertyName] = Yup.string()
              .required()
              .label(propertyName);
          }
        }
        if (
          element.type != "dataset" &&
          element.type != "group-dataset" &&
          element.type != "checkbox"
        ) {
          schemaObject[propertyName] = Yup.string()
            .required()
            .label(propertyName);
        }
      }
      if (element.type == "dataset") {
        element.data_set &&
          element.data_set.map((dset, parent_index) => {
            Array.from({
              length: element.data_set_row,
            }).map((dsubset, setIndex) => {
              if (
                element.data_set[parent_index]?.content_type?.value == "text"
              ) {
                if (element.data_set[parent_index]?.require) {
                  schemaObject[
                    `${element.name}text${parent_index}content${setIndex}`
                  ] = Yup.string()
                    .required()
                    .label(
                      `${element.data_set[parent_index]?.label} (${setIndex}) `
                    );
                }
              }
              if (
                element.data_set[parent_index]?.content_type?.value ==
                "dropdown"
              ) {
                if (element.data_set[parent_index]?.require) {
                  schemaObject[
                    `${element.name}select${parent_index}content${setIndex}`
                  ] = Yup.string()
                    .required()
                    .label(
                      `${element.data_set[parent_index]?.label} (${setIndex}) `
                    );
                }
              }
            });
          });
      }

      if (element.type == "group-dataset") {
        element.data_set.forEach((elementIn, gKey) => {
          if (elementIn.content_type.value == "checkbox") {
            if (elementIn?.require) {
              if (elementIn.content_array.every((obj) => !obj.checked)) {
                schemaObject[`${element.name}`] = Yup.string()
                  .required()
                  .label(`${elementIn?.label}`);
              }
            }
          }
          if (elementIn.content_type.value == "text") {
            if (elementIn?.require) {
              schemaObject[`${element.name + gKey}`] = Yup.string()
                .required()
                .label(`${elementIn?.label}`);
            }
          }
          if (elementIn.content_type.value == "dropdown") {
            if (elementIn?.require) {
              schemaObject[`${element.name + gKey}`] = Yup.string()
                .required()
                .label(`${elementIn?.label}`);
            }
          }
        });
      }
    }
    const schema = Yup.object().shape(schemaObject);
    return schema;
  };

  const handleInputChangeText = (
    e,
    fieldSheetData,
    setFieldSheetData,
    index,
    key,
    handleChange
  ) => {
    handleChange(e);

    let fieldSheetTextTemp = [...fieldSheetData];
    fieldSheetTextTemp[index].fields[key].value = e.target.value;

    setFieldSheetData(fieldSheetTextTemp);
  };

  const setCheckedValue = (setFieldValue, name, array) => {
    if (array.every((obj) => !obj.checked)) {
      setFieldValue(name, "");
    } else {
      setFieldValue(name, "checked");
    }
  };
  const handleCheckboxChange = (
    e,
    fieldSheetData,
    setFieldSheetData,
    index,
    key,
    checkKey,
    setFieldValue,
    setFieldError,
    field,
    check,
    array
  ) => {
    setFieldValue(field.name + `${check.label}`, !!e.target.checked);
    setFieldValue(field.name, "ok");

    let fieldSheetTextTemp = [...fieldSheetData];
    fieldSheetTextTemp[index].fields[key].data_set[checkKey].checked =
      !!e.target.checked;

    setFieldSheetData(fieldSheetTextTemp);
    setCheckedValue(setFieldValue, field.name, array);
  };
  const handleInputTextChangeDataset = (
    e,
    fieldSheetData,
    setFieldSheetData,
    index,
    key,
    parentIndex,
    setIndex,
    propName,
    handleChange
  ) => {
    handleChange(e);
    let fieldSheetTextTemp = [...fieldSheetData];
    fieldSheetTextTemp[index].fields[key].data_set[parentIndex][propName] =
      e.target.value;

    setFieldSheetData(fieldSheetTextTemp);
  };

  const handleSelectChangeDataset = (
    e,
    index,
    key,
    parent_index,
    setIndex,
    handleChange,
    field
  ) => {
    let fieldSheetTextTemp = [...fieldSheetData];
    const propName = `${field.name}select${parent_index}content${setIndex}`;
    fieldSheetTextTemp[index].fields[key].data_set[parent_index][propName] =
      e.target.value;
    setFieldSheetData(fieldSheetTextTemp);
  };

  const handleBack = () => {
    if (activeStep != 0) {
      setActiveStep(activeStep - 1);
    } else {
      navigate(-1);
    }
  };

  const handleSwitchSection = (switchStep) => {
    setActiveStep(switchStep);
  };

  

  const handleAutoSave = (values) => {
    // console.log("Auto-saving form values:", values);
    updateSheetData(values, true);
  };


  return (
    <section className="profile-main pt-4 inspector-bg">
      <Container className="">
        <Row>
          <Col md={12} lg={12}>
            <h1 className="fs-16  mb-3 mt-2">
              <img
                src={InspectionArrow}
                className="inspection-arrow"
                onClick={() => navigate(-1)}
              />
              <span className="fw-bold">Inspection for SR:</span>{" "}
              {serial_number} Model no.:
              <span className="fw-bold"> {model_number}</span>
            </h1>
          </Col>
        </Row>
      </Container>

      <>
        <Container className="">
          <Row>
            <Col md={12} lg={12} className="inspector-tab-p-0">
              <Card className="border-0 fieldSheetCover">
                <Card.Body className="br-10 p-4">
                  <div className="col-xl-12">
                    <Row className="mb-3">
                      <Col md="12 ">
                        <div className="d-flex justify-content-between  align-items-center headerLink ok">
                          {fieldSheetData.length > 0
                            ? fieldSheetData.map((section, index) => {
                                const isActiveOrPastStep = activeStep >= index || completedStep >= index;
                                return (
                                  <div
                                    className={`position-relative ${isActiveOrPastStep ? 'cursor-pointer' : ''}`}
                                    key={index}
                                    {...(isActiveOrPastStep && { onClick: () => handleSwitchSection(index) })}
                                  >
                                    {(activeStep > index || completedStep > index) && (
                                      <span className="activeIcon">
                                        <img src={activeIcon} />
                                      </span>
                                    )}
                                    <p
                                      className={
                                        activeStep == index ? `activeStep` : ""
                                      }
                                    >
                                      {section.title}
                                    </p>
                                  </div>
                                );
                              })
                            : "No Sheet available"}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <div
                          defaultActiveKey={activeStep}
                          id="justify-tab-example"
                          className="mb-5 field-sheet-tab"
                          justify
                        >
                          {fieldSheetData.length > 0 &&
                            fieldSheetData.map((section, index) => {
                              if (activeStep == index) {
                                return (
                                  <div
                                    key={index}
                                    eventKey={index}
                                    title={section.title}
                                    className={
                                      section.title == "Load Test"
                                        ? "loadTestCover"
                                        : ""
                                    }
                                  >
                                    <Row>
                                      <Col md="12">
                                        <h2 className="fs-16 fw-bold border-left-6 mb-4 text-uppercase">
                                          {section.title}{" "}
                                          {section?.help && (
                                            <img
                                              src={infoIcon}
                                              title={section?.help}
                                            />
                                          )}
                                        </h2>
                                      </Col>
                                    </Row>

                                    <Row className="sepratorDiv">
                                      <Formik
                                        validationSchema={getValidationSchema(
                                          section.fields
                                        )}
                                        initialValues={getInitialValues(
                                          section.fields
                                        )}
                                        onSubmit={handleSubmit}
                                      >

                                        {({
                                          handleSubmit,
                                          handleChange,
                                          handleBlur,
                                          values,
                                          errors,
                                          touched,
                                          setFieldValue,
                                          setFieldError,
                                          setValues,
                                        }) => (
                                          <>
                                            {/* Auto-save on any change */}
                                            <AutoSave onSave={handleAutoSave} />
                                            {section.fields.length > 0 &&
                                              section.fields.map(
                                                (field, key) => {
                                                  return (
                                                    <FieldArray
                                                      key={key}
                                                      name="friends"
                                                      render={(
                                                        arrayHelpers
                                                      ) => (
                                                        <>
                                                          {field.type ==
                                                            "group-dataset" &&
                                                            field.data_set
                                                              .length && (
                                                              <GroupDataset
                                                                data_set={
                                                                  field.data_set
                                                                }
                                                                setFieldSheetData={
                                                                  setFieldSheetData
                                                                }
                                                                field={field}
                                                                index={index}
                                                                dataKey={key}
                                                                touched={
                                                                  touched
                                                                }
                                                                handleBlur={
                                                                  handleBlur
                                                                }
                                                                handleChange={
                                                                  handleChange
                                                                }
                                                                values={values}
                                                                fieldSheetData={
                                                                  fieldSheetData
                                                                }
                                                                transformedArray={
                                                                  transformedArray
                                                                }
                                                                setFieldValue={
                                                                  setFieldValue
                                                                }
                                                                errors={errors}
                                                              />
                                                            )}
                                                          {field.type ===
                                                            "text" && (
                                                            <Col
                                                              md="6"
                                                              key={key}
                                                            >
                                                              <div
                                                                className={
                                                                  section.is_testing ===
                                                                  false
                                                                    ? "fieldSheetBox"
                                                                    : ""
                                                                }
                                                              >
                                                                <InputText
                                                                  controlId={
                                                                    field.name
                                                                  }
                                                                  placeholder={
                                                                    field.title
                                                                  }
                                                                  label={
                                                                    field.title
                                                                  }
                                                                  className="form-control"
                                                                  touched={
                                                                    touched[
                                                                      field.name
                                                                    ]
                                                                  }
                                                                  handleBlur={
                                                                    handleBlur
                                                                  }
                                                                  handleChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputChangeText(
                                                                      e,
                                                                      fieldSheetData,
                                                                      setFieldSheetData,
                                                                      index,
                                                                      key,
                                                                      handleChange
                                                                    )
                                                                  }
                                                                  errorsField={
                                                                    errors[
                                                                      field.name
                                                                    ]
                                                                  }
                                                                  value={
                                                                    values[
                                                                      field.name
                                                                    ]
                                                                  }
                                                                />
                                                                {!section.is_testing && (
                                                                  <label className="fieldSheetLabel">
                                                                    {
                                                                      field.title
                                                                    }
                                                                  </label>
                                                                )}
                                                              </div>
                                                            </Col>
                                                          )}
                                                          {/* textarea condition */}
                                                          {field.type ===
                                                            "textarea" && (
                                                            <Col
                                                              md="12"
                                                              key={key}
                                                            >
                                                              <div className="mt-3">
                                                                <InputTextArea
                                                                  controlId={
                                                                    field.name
                                                                  }
                                                                  placeholder={
                                                                    field.title
                                                                  }
                                                                  label={
                                                                    field.title
                                                                  }
                                                                  className="form-control"
                                                                  touched={
                                                                    touched[
                                                                      field.name
                                                                    ]
                                                                  }
                                                                  handleBlur={
                                                                    handleBlur
                                                                  }
                                                                  handleChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputChangeText(
                                                                      e,
                                                                      fieldSheetData,
                                                                      setFieldSheetData,
                                                                      index,
                                                                      key,
                                                                      handleChange
                                                                    )
                                                                  }
                                                                  errorsField={
                                                                    errors[
                                                                      field.name
                                                                    ]
                                                                  }
                                                                  value={
                                                                    values[
                                                                      field.name
                                                                    ]
                                                                  }
                                                                />
                                                                {/* <label className="fieldSheetLabel">{field.title}</label> */}
                                                              </div>
                                                            </Col>
                                                          )}
                                                          {/* dropdown condition */}
                                                          {field.type ===
                                                            "dropdown" && (
                                                            <Col
                                                              md="6"
                                                              key={key}
                                                            >
                                                              <div
                                                                className={
                                                                  section.is_testing ===
                                                                  false
                                                                    ? "fieldSheetBox"
                                                                    : ""
                                                                }
                                                              >
                                                                <InputSelect
                                                                  controlId={
                                                                    field.name
                                                                  }
                                                                  label={
                                                                    section.is_testing ===
                                                                    true
                                                                      ? field.label
                                                                      : ""
                                                                  }
                                                                  placeholder={
                                                                    field.label
                                                                  }
                                                                  touched={
                                                                    touched[
                                                                      field.name
                                                                    ]
                                                                  }
                                                                  handleBlur={
                                                                    handleBlur
                                                                  }
                                                                  handleChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputChangeText(
                                                                      e,
                                                                      fieldSheetData,
                                                                      setFieldSheetData,
                                                                      index,
                                                                      key,
                                                                      handleChange
                                                                    )
                                                                  }
                                                                  errorsField={
                                                                    errors[
                                                                      field.name
                                                                    ]
                                                                  }
                                                                  value={
                                                                    values[
                                                                      field.name
                                                                    ]
                                                                  }
                                                                  options={transformedArray(
                                                                    field?.data_set
                                                                  )}
                                                                  readOnly={
                                                                    false
                                                                  }
                                                                />
                                                                {!section.is_testing && (
                                                                  <label className="fieldSheetLabel">
                                                                    {
                                                                      field.title
                                                                    }
                                                                  </label>
                                                                )}
                                                              </div>
                                                            </Col>
                                                          )}
                                                          {/* checkbox  */}
                                                          {field.type ===
                                                            "checkbox" && (
                                                            <Col
                                                              md="6"
                                                              key={key}
                                                            >
                                                              <div className="">
                                                                <label>
                                                                  {field?.label}
                                                                </label>
                                                              </div>
                                                              <div className="fieldSheetBox ">
                                                                {field.data_set &&
                                                                  field.data_set.map(
                                                                    (
                                                                      check,
                                                                      checkKey
                                                                    ) => {
                                                                      return (
                                                                        <div
                                                                          className="checkboxWrapper"
                                                                          key={
                                                                            checkKey
                                                                          }
                                                                        >
                                                                          <input
                                                                            type="checkbox"
                                                                            name={
                                                                              field.name +
                                                                              `${check.label}`
                                                                            }
                                                                            checked={
                                                                              values[
                                                                                field.name +
                                                                                  `${check.label}`
                                                                              ]
                                                                            }
                                                                            onChange={(
                                                                              e
                                                                            ) =>
                                                                              handleCheckboxChange(
                                                                                e,
                                                                                fieldSheetData,
                                                                                setFieldSheetData,
                                                                                index,
                                                                                key,
                                                                                checkKey,
                                                                                setFieldValue,
                                                                                setFieldError,
                                                                                field,
                                                                                check,
                                                                                field.data_set
                                                                              )
                                                                            }
                                                                            touched={
                                                                              touched[
                                                                                field.name +
                                                                                  `${check.label}`
                                                                              ]
                                                                            }
                                                                            handleBlur={
                                                                              handleBlur
                                                                            }
                                                                            errorsField={
                                                                              errors[
                                                                                field.name +
                                                                                  `${check.label}`
                                                                              ]
                                                                            }
                                                                          />
                                                                          <label>
                                                                            {
                                                                              check.label
                                                                            }
                                                                          </label>
                                                                        </div>
                                                                      );
                                                                    }
                                                                  )}
                                                              </div>
                                                              {errors[
                                                                field.name
                                                              ] && (
                                                                <p className="text-danger">
                                                                  {
                                                                    errors[
                                                                      field.name
                                                                    ]
                                                                  }
                                                                </p>
                                                              )}
                                                            </Col>
                                                          )}

                                                          {/* data set start  kok*/}
                                                          {field.type ===
                                                            "dataset" && (
                                                            <Row
                                                              key={key}
                                                              className="mb-4"
                                                            >
                                                              {field.data_set &&
                                                                field.data_set.map(
                                                                  (
                                                                    val,
                                                                    parent_index
                                                                  ) => {
                                                                    return (
                                                                      <Col
                                                                        key={
                                                                          parent_index
                                                                        }
                                                                        className="datasetIndex"
                                                                      >
                                                                        <>
                                                                          {Array.from(
                                                                            {
                                                                              length:
                                                                                field.data_set_row,
                                                                            }
                                                                          ).map(
                                                                            (
                                                                              set,
                                                                              setIndex
                                                                            ) => {
                                                                              return (
                                                                                <div
                                                                                  key={
                                                                                    setIndex
                                                                                  }
                                                                                >
                                                                                  {field
                                                                                    .data_set[
                                                                                    parent_index
                                                                                  ]
                                                                                    .content_type
                                                                                    .value ===
                                                                                    "label" && (
                                                                                    <div className="labelCover">
                                                                                      {setIndex ===
                                                                                      0 ? (
                                                                                        <p
                                                                                          className="fw-bold mb-3 minHeight20"
                                                                                          ref={
                                                                                            divRef
                                                                                          }
                                                                                          style={{
                                                                                            height: `${height}px`,
                                                                                          }}
                                                                                        >
                                                                                          {setIndex ===
                                                                                          0
                                                                                            ? field
                                                                                                .data_set[
                                                                                                parent_index
                                                                                              ]
                                                                                                .label
                                                                                            : ""}
                                                                                        </p>
                                                                                      ) : (
                                                                                        ""
                                                                                      )}
                                                                                      <div className="textPading">
                                                                                        {
                                                                                          field
                                                                                            .data_set[
                                                                                            parent_index
                                                                                          ]
                                                                                            .content_array[
                                                                                            setIndex
                                                                                          ]
                                                                                            .label
                                                                                        }
                                                                                      </div>
                                                                                    </div>
                                                                                  )}

                                                                                  {field
                                                                                    .data_set[
                                                                                    parent_index
                                                                                  ]
                                                                                    .content_type
                                                                                    .value ===
                                                                                    "text" && (
                                                                                    <>
                                                                                      {setIndex ===
                                                                                      0 ? (
                                                                                        <p
                                                                                          className="fw-bold mb-3 minHeight20 pb-3"
                                                                                          ref={
                                                                                            divRef
                                                                                          }
                                                                                          style={{
                                                                                            height: `${height}px`,
                                                                                          }}
                                                                                        >
                                                                                          {
                                                                                            field
                                                                                              .data_set[
                                                                                              parent_index
                                                                                            ]
                                                                                              .label
                                                                                          }
                                                                                        </p>
                                                                                      ) : (
                                                                                        ""
                                                                                      )}
                                                                                      <div>
                                                                                        <InputText
                                                                                          controlId={`${field.name}text${parent_index}content${setIndex}`}
                                                                                          placeholder={
                                                                                            field
                                                                                              .data_set[
                                                                                              parent_index
                                                                                            ]
                                                                                              .content
                                                                                          }
                                                                                          className="form-control"
                                                                                          tabindex={
                                                                                            key +
                                                                                            "" +
                                                                                            setIndex +
                                                                                            "" +
                                                                                            parent_index +
                                                                                            1
                                                                                          }
                                                                                          touched={
                                                                                            touched[
                                                                                              `${field.name}text${parent_index}content${setIndex}`
                                                                                            ]
                                                                                          }
                                                                                          handleBlur={
                                                                                            handleBlur
                                                                                          }
                                                                                          handleChange={(
                                                                                            e
                                                                                          ) =>
                                                                                            handleInputTextChangeDataset(
                                                                                              e,
                                                                                              fieldSheetData,
                                                                                              setFieldSheetData,
                                                                                              index,
                                                                                              key,
                                                                                              parent_index,
                                                                                              setIndex,
                                                                                              `${field.name}text${parent_index}content${setIndex}`,
                                                                                              handleChange
                                                                                            )
                                                                                          }
                                                                                          errorsField={
                                                                                            errors[
                                                                                              `${field.name}text${parent_index}content${setIndex}`
                                                                                            ]
                                                                                          }
                                                                                          value={
                                                                                            values[
                                                                                              `${field.name}text${parent_index}content${setIndex}`
                                                                                            ]
                                                                                          }
                                                                                        />
                                                                                      </div>
                                                                                    </>
                                                                                  )}

                                                                                  {field
                                                                                    .data_set[
                                                                                    parent_index
                                                                                  ]
                                                                                    .content_type
                                                                                    .value ===
                                                                                    "dropdown" && (
                                                                                    <>
                                                                                      {setIndex ===
                                                                                      0 ? (
                                                                                        <p
                                                                                          className="fw-bold mb-3 minHeight20"
                                                                                          ref={
                                                                                            divRef
                                                                                          }
                                                                                          style={{
                                                                                            height: `${height}px`,
                                                                                          }}
                                                                                        >
                                                                                          {
                                                                                            field
                                                                                              .data_set[
                                                                                              parent_index
                                                                                            ]
                                                                                              .label
                                                                                          }
                                                                                        </p>
                                                                                      ) : (
                                                                                        ""
                                                                                      )}
                                                                                      <div>
                                                                                        <InputSelect
                                                                                          controlId={`${field.name}select${parent_index}content${setIndex}`}
                                                                                          tabindex={
                                                                                            key +
                                                                                            "" +
                                                                                            setIndex +
                                                                                            "" +
                                                                                            parent_index +
                                                                                            1
                                                                                          }
                                                                                          placeholder={
                                                                                            field
                                                                                              .data_set[
                                                                                              parent_index
                                                                                            ]
                                                                                              .content_array[
                                                                                              setIndex
                                                                                            ]
                                                                                              ?.label
                                                                                          }
                                                                                          handleChange={(
                                                                                            e
                                                                                          ) =>
                                                                                            handleSelectChangeDataset(
                                                                                              e,
                                                                                              index,
                                                                                              key,
                                                                                              parent_index,
                                                                                              setIndex,
                                                                                              handleChange,
                                                                                              field
                                                                                            )
                                                                                          }
                                                                                          touched={
                                                                                            touched[
                                                                                              `${field.name}select${parent_index}content${setIndex}`
                                                                                            ]
                                                                                          }
                                                                                          handleBlur={
                                                                                            handleBlur
                                                                                          }
                                                                                          errorsField={
                                                                                            errors[
                                                                                              `${field.name}select${parent_index}content${setIndex}`
                                                                                            ]
                                                                                          }
                                                                                          value={
                                                                                            values[
                                                                                              `${field.name}select${parent_index}content${setIndex}`
                                                                                            ]
                                                                                          }
                                                                                          options={transformedArray(
                                                                                            field
                                                                                              .data_set[
                                                                                              parent_index
                                                                                            ]
                                                                                              .content_array
                                                                                          )}
                                                                                          readOnly={
                                                                                            false
                                                                                          }
                                                                                        />
                                                                                      </div>
                                                                                    </>
                                                                                  )}
                                                                                </div>
                                                                              );
                                                                            }
                                                                          )}
                                                                        </>
                                                                      </Col>
                                                                    );
                                                                  }
                                                                )}
                                                            </Row>
                                                          )}
                                                        </>
                                                      )}
                                                    />
                                                  );
                                                }
                                              )}
                                            <div className="d-flex justify-content-end inspector-footer inspector-footer-form pt-3 pb-3 pe-3 ps-3 buttonCover">
                                              <Container>
                                                <Row>
                                                  <Col
                                                    sm="12"
                                                    className="d-flex justify-content-between"
                                                  >
                                                    <button
                                                      type="submit"
                                                      onClick={() => {
                                                        handleBack();
                                                      }}
                                                      className="btn btn-default  my-1 fw-semibold"
                                                    >
                                                      Back
                                                    </button>
                                                    {btnLoading ? (
                                                      <Button
                                                        disabled={true}
                                                        variant="primary"
                                                        className="btn btn-primary my-1 fw-semibold  wait-cursor  "
                                                      >
                                                        <Spinner size="sm" />
                                                      </Button>
                                                    ) : (
                                                      <Button
                                                        type="submit"
                                                        variant="primary"
                                                        onClick={(e) => {
                                                          setTempSteps(
                                                            activeStep + 1
                                                          );
                                                          handleSubmit();
                                                        }}
                                                        className="btn btn-primary my-1 fw-semibold"
                                                      >
                                                        Next
                                                      </Button>
                                                    )}
                                                  </Col>
                                                </Row>
                                              </Container>
                                            </div>
                                          </>
                                        )}
                                      </Formik>
                                    </Row>
                                  </div>
                                );
                              }
                            })}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </>

      <SnackbarToast showSnackBar={showSnackBar} handleClose={handleClose} />
      <Loader isLoading={loading} />
    </section>
  );
};
